import React from 'react';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';
import BarChart from '../charts/barChart.jsx';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import {injectIntl, intlShape} from 'react-intl';

let classCounter;

class ChartCards extends React.Component {
  static propTypes = {
    cards: PropTypes.array.isRequired,
    intl: intlShape.isRequired,
  };

  componentWillMount() {
    classCounter = 1;
  }

  getClass = (index) => {
    if (index === 0) {
      classCounter = 1;
    }

    if (classCounter === 1) {
      classCounter = 2;
      return 'box-product border-right col-sm-4';
    }

    if (classCounter === 2) {
      classCounter = 3;
      return 'box-product border-right border-left col-sm-4';
    }

    classCounter = 1;
    return 'box-product border-left col-sm-4';
  };

  render() {
    const cards = cloneDeep(this.props.cards)
      .map((card, i) => {
        card.Unit = this.props.intl.formatMessage({id: card.Unit});

        return <div key={i}
                    className={this.getClass(i)}>
          <label>{card.ProductName}</label>
          <BarChart
            axisColor={'#f7f7f7'}
            axisThickness={0}
            bulletBorderThickness={1}
            colors={['#79858f', '#009fde', '#e35007', '#79bd20', '#8045ad', '#ba2245', '#f0c000', '#9bb8d1', '#2eccd1']}
            containerHeight={120}
            data={[
              {name: this.props.intl.formatMessage({id: 'general.recommended'}), value: card.Recommended},
              {name: this.props.intl.formatMessage({id: 'general.purchased'}), value: card.Purchased}]}
            gridAlpha={0}
            gridThickness={0}
            inside={false}
            labelRotation={0}
            labelText={'[[value]] ' + card.Unit + '\n[[category]]'}
            labelsEnabled={false}
            lineAlpha={1}
            lineThickness={2}
            maximum={card.scale * 2} // Try setting this larger so labels don't vanish on max bars
            newCategoryLabel={''}
            randomColors={true}
            rotate={true}
            showBalloon={false}
            tickLength={-30}
          />
          <span className="chart-card-date chart-card-text"><FormattedMessage id="general.last.purchased"/>:
            {card.LastPurchaseDate && card.LastPurchaseDate.length > 0 ? moment(card.LastPurchaseDate).format(dateTimeFormats.numeralDate) : ''}</span>
          <span className="chart-card-text"><FormattedMessage id="customer.product.recommendation.source"/>: <FormattedMessage id={card.Source}/></span>
        </div>;
      },
    );

    return <div className="chart-card container-fluid">
      <div className="row">
        {cards}
      </div>
    </div>;
  }
}

export default injectIntl(ChartCards);
